import { ApiHelper } from './apiHelper';

export class SiteApi {
    getSiteSettings(
        domainName,
        language,
        successCallback = null,
        failureCallback = null
    ) {
        let query = `?domainName=${encodeURIComponent(domainName)}&language=${language}`;

        let dataUrl = '/api/site/getsitesettings' + query;
        new ApiHelper().getData(dataUrl, successCallback, failureCallback);
    }

    loadDowntimeConfiguration(successCallback = null, failureCallback = null) {
        var url = '/api/site/getdowntimeconfig';
        new ApiHelper().getData(url, successCallback, failureCallback);
    }
}
